import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPresupuesto } from "../../redux/actions/actionPresupuesto";
import {
  Document,
  View,
  Page,
  Text,
  PDFViewer,
  Image,
} from "@react-pdf/renderer";
import imgHt from "../../imagenes/imgHt.png";
import { format } from "date-fns";

export default function PresupuestoPDF() {
  let date = format(new Date(), "yyyy/MM/dd");

  const dispatch = useDispatch(); 
  const presupuestos = useSelector(state => state.presupuesto.allPresupuesto)  
  
  useEffect(() => {
    dispatch(getPresupuesto())    
  }, [dispatch])
  
  console.log(presupuestos);
  //console.log(id)

      
  const presupuestoUltimo = presupuestos[0] && presupuestos[0][presupuestos[0].length - presupuestos[0].length]
  console.log(presupuestoUltimo)

  
  return (
    <div>
    {presupuestoUltimo !== undefined ? 
    <PDFViewer style={{ width: "118vh", height: "90vh" }}>
      <Document>
        <Page size="A4" style={{display:"flex"}}>
        
          <View style={{display:"flex"}}>
            <View style={{ display: "flex"}}>
              <View
                style={{
                  widt: "200px",
                  height: "125px",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
          
                <View style={{ marginLeft: "40px" }}>
                  
                  <Image
                    href={imgHt}
                    style={{ width: "100px", height: "60px" }}
                  />
                  <View style={{ marginLeft: "11px" }}>
                   
                    <Text style={{ fontSize: "9pt" }}>Grupo HT</Text>
                    <Text style={{ fontSize: "9pt" }}>Pedro Lozano 5066</Text>
                    <Text style={{ fontSize: "9pt" }}>CABA</Text>
                    <Text style={{ fontSize: "9pt" }}>Argentina</Text>
                    <Text style={{ fontSize: "9pt" }}>Tel: 15-57619270</Text>
                    <Text style={{ fontSize: "9pt" }}>CUIT: </Text>
                  </View>
                </View>
                <View style={{ marginTop: "40px", marginRight: "40px" }}>
                 
                  <Text>Remito</Text>
                  <Text style={{ fontSize: "14pt" }}>
                    N°: 0001- {presupuestoUltimo.numberDocument}
                  </Text>
                  <Text> </Text>
                  <Text style={{ fontSize: "9pt" }}>
                    Fecha de Emisión: {date}
                  </Text>
                </View>
              </View>

              <View>
                <View
                  style={{
                    width: "530px",
                    height: "50px",
                    borderTop: "1px",
                    borderColor: "grey",
                    flexDirection:"row",
                    paddingTop:"5px",
                    marginLeft:"30px",                    
                  }}
                > 
                  <View style={{ flexDirection: "column", marginLeft:"10px", width:"185px"}}>
                    <Text style={{ fontSize: "9pt" }}>Compañia: {presupuestoUltimo.client_id.nameCompany}</Text>
                    <Text style={{ fontSize: "9pt", paddingTop:"5px"}}>Direccion: {presupuestoUltimo.client_id.address}</Text>
                  </View>
                  <View style={{marginLeft: "40px", width:"185px"}}>
                    <Text style={{ fontSize: "9pt" }}>Nombre: {presupuestoUltimo.client_id.name}</Text>
                    <Text style={{ fontSize: "9pt", paddingTop:"5px"}}>Telefonos: {presupuestoUltimo.client_id.telephoneNumber}</Text>
                  </View>
                  <View style={{marginLeft:"50px", width:"185px", marginRight:"5px"}}>
                    <Text style={{ fontSize: "9pt" }}>Apellido: {presupuestoUltimo.client_id.lastName}</Text>
                    <Text style={{ fontSize: "9pt", paddingTop:"5px"}}>Email: {presupuestoUltimo.client_id.email}</Text>
                  </View>
                </View>

                <View style={{width:"530px", height:"25px", borderTop:"1px", borderBottom:"1px", borderColor:"grey", flexDirection:"row", paddingTop:"5px", marginLeft:"30px"}}>
                  <View style={{maxWidth:"185px", minWidth:"185px", boder:"1px", borderColor:"black", marginLeft:"50px"}}>
                  <Text style={{ fontSize: "9pt"}}>
                    Dir. Evento: {presupuestoUltimo.addressEvent}
                  </Text>
                  </View>
                  <View style={{width:"185px"}}>
                  <Text style={{ fontSize: "9pt"}}>
                    Fecha Envio:{" "}
                    {format(new Date(presupuestoUltimo.dateSend), "dd/MM/yyyy")}
                  </Text>
                  </View>
                  <View style={{width:"185px"}}>
                  <Text style={{ fontSize: "9pt"}}>
                    Fecha Retorno:{" "}
                    {format(new Date(presupuestoUltimo.dateReception), "dd/MM/yyyy")}
                  </Text>
                  </View>
                </View>

                  <View style={{height:"20px", display:"flex", marginLeft:"30px", width:"530px"}}>
                    <Text style={{fontSize:"12pt", paddingTop:"5px"}}>Articulos</Text>
                  </View>
                  <View style={{display:"flex", flexDirection:"row", width:"530px", paddingTop:"5px", 
                                paddingBottom:"4px", borderBottom:"1px", borderColor:"grey", marginLeft:"30px", fontSize:"11pt"}}>
                    <Text style={{width:"130px", paddingLeft:"5px"}}>Nombre</Text>
                    <Text style={{width:"300px"}}>Descripcion</Text>
                    <Text style={{width:"30px"}}>Un.</Text>
                    <Text style={{width:"50px"}}>Precio Un.</Text>
                    <Text style={{width:"50px"}}>Importe Total</Text>
                  </View>
                  <View style={{marginLeft:"30px"}}>
                    {presupuestoUltimo && presupuestoUltimo.quantityItems.map(e=>
                      <View style={{display:"flex", flexDirection:"row", width:"530px", height:"15px", borderBottom:"1px", borderColor:"black", alignItems:"center"}}>                        
                        <Text style={{width:"130px", borderColor:"black", borderLeft:"1px", paddingLeft:"5px", borderRight:"1px", fontSize:"9pt"}}>{e.name}</Text>                        
                        <Text style={{width:"300px", borderRight:"1px", fontSize:"9pt"}}>{e.descrip}</Text>                        
                        <Text style={{width:"30px", justifyContent:"center", borderRight:"1px", borderColor:"black", paddingRight:"2px", fontSize:"9pt", textAlign:"right"}}>{e.quantity}</Text>                        
                        <Text style={{width:"50px", alignContent:"center", borderRight:"1px", borderColor:"black", fontSize:"9pt", textAlign:"right", paddingRight:"2px"}}>{e.price}</Text>                        
                        <Text style={{width:"50px", alignContent:"center", borderRight:"1px", borderColor:"black", fontSize:"9pt", textAlign:"right", paddingRight:"2px"}}>{e.totalPrice}</Text>                        
                      </View>
                    )}
                    </View>
                    <View style={{display:"flex", flexDirection:"row", width:"530px", fontSize:"12pt", justifyContent:"space-between", paddingTop:"5px", paddingBottom:"4px", borderBottom:"1px", borderColor:"grey", marginLeft:"30px", marginTop:"30px"}}>                    
                    <Text style={{width:"100px", marginLeft:"5px"}}>Subtotal</Text>
                    <Text style={{width:"300px", textAlign:"right"}}>{presupuestoUltimo.subtotal}</Text>
                    </View>
                    <View style={{display:"flex", flexDirection:"row", width:"530px", fontWeight:"bold", fontSize:"12pt", paddingTop:"5px", paddingBottom:"4px", borderBottom:"1px", borderColor:"grey", marginLeft:"30px"}}>
                        <Text style={{width:"150px", marginLeft:"5px"}}>Coeficiente</Text>
                        <Text style={{width:"100px", textAlign:"right"}}>{presupuestoUltimo.coeficiente}</Text>
                        <Text style={{width:"300px", textAlign:"right"}}>Total * Coeficiente</Text>
                        <Text style={{width:"300px", textAlign:"right"}}>{presupuestoUltimo.totalCoeficiente}</Text>                         
                    </View>
                  
              </View>
            </View>
          </View>
        
        </Page>
      </Document>
    </PDFViewer>
    : <div>No va</div>}
    </div>
  );
}
